// The referee's open invitations, on their own card above their tournaments

import { useMemo } from 'react';
import RefereeInvitation from './RefereeInvitation';
import { useEntities, useMyRefereeRoster } from '../utils/hooks';
import { RefereeStatuses } from '../utils/enums';
import './RefereeInvitations.scss';

export default function RefereeInvitations() {
  const { entries } = useMyRefereeRoster();
  const pending = useMemo(
    () => entries.filter((e) => e.status === RefereeStatuses.INVITED),
    [entries],
  );

  const { entities, isResolved } = useEntities(
    'tournaments',
    pending.map((e) => e.tournamentId),
  );
  const tournamentById = useMemo(
    () => new Map(entities.filter(Boolean).map((t) => [t.id, t])),
    [entities],
  );

  if (pending.length === 0) return null;

  return (
    <div className='referee-invitations'>
      <h5>Invitations</h5>
      {pending.map((entry) => {
        const tournament = tournamentById.get(entry.tournamentId);
        return (
          <RefereeInvitation
            key={entry.tournamentId}
            entry={entry}
            tournamentName={tournament?.name ?? 'Tournament'}
            // The registry drops a deleted tournament: it resolves as missing
            isDeleted={tournament ? tournament.active !== true : isResolved}
          />
        );
      })}
    </div>
  );
}
